<template>
  <div></div>
</template>

<script>
import axios from "@/axios.js";

export default {
  data() {
    return {};
  },
  created() {
    this.$vs.loading();

    const { token, userId, organization, redirectTo } = this.$route.query;
    if (!token || !userId) return;

    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("accessToken", token);

    this.$store.commit("auth/SET_ACCESS_TOKEN", token);
    this.$store.commit("auth/SET_LOGGEDIN_STATE", true);

    this.$store.dispatch("users/fetchUser", userId).then((res) => {
      localStorage.setItem(
        "user",
        JSON.stringify({
          _id: res.data._id,
          email: res.data.email,
        })
      );
      this.$store.commit("auth/SET_USER", res.data);

      this.$store.commit(
        "editor/SET_PERSONAL_EVALUATION",
        res.data.personalEvaluation[0]
      );
      this.$store.commit("editor/SET_CAREER_HISTORY", res.data.careerHistory);
      this.$store.commit(
        "editor/SET_EDUCATIONAL_QUALIFICATIONS",
        res.data.educationalQualifications
      );
      this.$store.commit("editor/SET_PROJECTS", res.data.projects);
      this.$store.commit(
        "editor/SET_EXTRA_CURRICULAR",
        res.data.extraCurricular[0]
      );
      this.$store.commit("editor/SET_PERSONALITY", res.data.personality[0]);

      if (organization === "gala") {
        if (redirectTo) {
          window.location.href = `/gala/${redirectTo}`;
        } else {
          window.location.href = `/gala/preview`;
        }
      } else {
        if (redirectTo) {
          window.location.href = `/${redirectTo}`;
        } else {
          window.location.href = `/preview`;
        }
      }
    });
  },
};
</script>
